<app-navbar />

<main id="main-content">
  <section class="section notfound-section">
    <div class="container">
      <div class="notfound-panel">
        <span class="notfound-code" aria-hidden="true">404</span>
        <h1>We could not find that page</h1>
        <p class="notfound-lead">
          The link may be broken, or the page may have moved. Everything you need to verify deceased
          consumers is still one click away.
        </p>

        <div class="actions-row center">
          <a class="btn btn-primary" [routerLink]="[routes.home.url]">Back to home</a>
          <a class="btn btn-outline" [routerLink]="[routes.contact.url]">Contact support</a>
        </div>
      </div>

      <div class="notfound-links">
        @for (item of suggestions; track item.url) {
          <a class="notfound-link" [routerLink]="[item.url]">
            <span class="notfound-link-title">{{ item.label }}</span>
            <span class="notfound-link-note">{{ item.note }}</span>
          </a>
        }
      </div>
    </div>
  </section>
</main>

<app-footer />
